/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

export default function CustomSpin ( props){
    return (
        <Spin
            spinning = {props.spinning}
            indicator={
                <LoadingOutlined
                    style={{
                        fontSize: 48,
                    }}
                    spin
                />
            }
            style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', color: '#ac4df8' }}
            fullscreen
        />
    );
}